import { render } from "./LoyaltySettings.vue?vue&type=template&id=1d049cc4&scoped=true"
import script from "./LoyaltySettings.vue?vue&type=script&lang=js"
export * from "./LoyaltySettings.vue?vue&type=script&lang=js"

import "./LoyaltySettings.vue?vue&type=style&index=0&id=1d049cc4&scoped=true&lang=css"
import "./LoyaltySettings.vue?vue&type=style&index=1&id=1d049cc4&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d049cc4"]])

export default __exports__